import { ITableHeaderComponentProps } from "@/interfaces/Table";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";

const AllCallLogsHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
  query,
}) => {
  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Tableau de bord d'appel</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher un client ou un numéro"
              aria-label="Rechercher un client ou un numéro"
              value={query ?? ""}
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
    </div>
  );
};

export default AllCallLogsHeader;
